import React from "react";

function GridBackground() {
  return <div className="grid-bg" aria-hidden="true" />;
}

export default GridBackground;
